import React, { useEffect, useRef } from "react";
import "../../UserDashboard/HomeDashboard/HomeDashboard.css";
import user from "../../../../Image/user.jpg";
import { Link, Outlet } from "react-router-dom";
import AdminMenu from "../../../Shard/Navbar/AdminMenu";
import Footer from "../../../Shard/Footer/Footer";

const AdminHomeDashboard = ({ sidebarOpen, setSidebarOpen }) => {
  const ref = useRef(null);
  const isAdmin = true;
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        setSidebarOpen(false);
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);
  return (
    <div>
      <AdminMenu sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
      {isAdmin && (
        <div className="dashboardMain ">
          <div
            className={sidebarOpen ? "adminSidebarBefore" : "adminSidebarAfter"}
          >
            <div className="userMenuItems">
              <div className="userProfile">
                <img src={user} alt="" className="userImg" />
                <h6 className="user_Name">Ujwal Timilsina</h6>
              </div>
              <h4 className="overview">Overview</h4>
              <div className="adminDashboardMenu" ref={ref}>
                <ul>
                  <li>
                    <Link to={"/siteadmin"}>Dashboard</Link>
                  </li>
                  <li>
                    <Link to={"/siteadmin/customer"}>Customer</Link>
                  </li>
                  <li>
                    <Link to={"/siteadmin/req"}>RFQ</Link>
                  </li>
                  <li>
                    <Link>Roles and Permissions</Link>
                  </li>
                  <li>
                    <Link to={"/siteadmin/article"}>Article</Link>
                  </li>
                  <li>
                    <Link to={"/siteadmin/product-type"}>Product Type</Link>
                  </li>
                  <li>
                    <Link to={"/siteadmin/equipment-type"}>Equipment Type</Link>
                  </li>
                  <li>
                    <Link to={"/siteadmin/vehicle-type"}>Vehicle Type</Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <Outlet />
        </div>
      )}
      <Footer />
    </div>
  );
};

export default AdminHomeDashboard;
